export const mutations = {
  SEARCH_RESULT: 'SEARCH_RESULT',
  TUTORIAL_PLAYLIST_BY_CATEGORY: 'TUTORIAL_PLAYLIST_BY_CATEGORY',
  CURRENT_LAYOUT: 'CURRENT_LAYOUT',
  CALLING_API: 'CALLING_API',
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  TOGGLE_MODAL: 'TOGGLE_MODAL',
  SHOW_ICON: 'SHOW_ICON',
  HIDE_ICON: 'HIDE_ICON',
  MOMENT_CLOSE: 'MOMENT_CLOSE',
  MOMENT_OPEN: 'MOMENT_OPEN',
  ACCOUNT_UPDATE_GETHELP_DATA: 'ACCOUNT_UPDATE_GETHELP_DATA',
};

export const actions = {
  INPUT_SEARCH_ARTICLES: 'searchArticles',
  TUTORIAL_PLAYLIST_BY_ID: 'getVideoByCategory',
  GET_VIDEO_BY_ID: 'getVideoById',
  OPEN_GETHELP_MODAL: 'openGethelpModal',
  CLOSE_GETHELP_MODAL: 'closeGethelpModal',
  TOGGLE_GETHELP_MODAL: 'toggleGethelpModal',
  HIDE_ICON_GETHELP: 'hideIconGetHelp',
  SHOW_ICON_GETHELP: 'showIconGetHelp',
  SYSTEM_SETTING_GETHELP: 'sytemSettingGetHelp',
};
